import React from 'react';
import { serviceFor } from './serviceCatalog';

// The logo tile on every card and row. A known service gets its brand colour
// and initials (no vendor logo files — nothing to license or keep updated);
// anything else falls back to its category's emoji and colour, as before.
const ServiceAvatar = ({ record, size = 'md' }) => {
    const service = serviceFor(record);
    const sizeClass = size === 'sm' ? 'pay-card-icon-sm' : size === 'lg' ? 'service-avatar-lg' : '';

    if (service) {
        return (
            <span
                className={`pay-card-icon service-avatar ${sizeClass}`}
                style={{ background: service.color }}
                title={service.name}
                aria-hidden="true"
            >
                {service.initials}
            </span>
        );
    }

    const category = record?.category || {};
    const color = category.color || '#6B7280';
    const fallbackIcon = record?.paymentType === 'usage' ? '⚡' : record?.paymentType === 'onetime' ? '🧾' : '🔁';
    return (
        <span className={`pay-card-icon ${sizeClass}`} style={{ background: `${color}1F`, color }} aria-hidden="true">
            {category.icon || fallbackIcon}
        </span>
    );
};

export default ServiceAvatar;
